import { useEffect, useState } from "react";
import InvoicePayors from "./invoice-payors";
import { sunboundPayProxy } from '@proxies';
import { useSpinnerContext } from '@contexts';
import { Location, useLocation } from "react-router-dom";
import type { Invoice, InvoicePayor, SessionData, AccountPayor } from '@app-types';

interface LocationState {
    invoice: Invoice;
    invoicePayors: InvoicePayor[];
    idProductType: number;
    account: SessionData;
    idEditPayor?: number;
}

const StepEnrollmentPayors = () => {

    const { setSpinnerShow } = useSpinnerContext();
    const [accountPayors, setAccountPayors] = useState<AccountPayor[] | null>(null);
    const location = useLocation() as Location<LocationState>;
    const {
        state: {
            invoice,
            invoicePayors,
            idProductType,
            account,
            idEditPayor
        }
    } = location;
    const { idAccount } = account;

    useEffect(() => {
        (async () => {
            setSpinnerShow(true);
            try {
                const response = await sunboundPayProxy.getAccountPayors(idAccount);
                setAccountPayors(response);
            } catch (_error) {
                // do nothing
            }
            setSpinnerShow(false);
        })();
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (!accountPayors) {
        return null;
    }

    return (
        <InvoicePayors
            accountPayors={accountPayors}
            invoice={invoice}
            invoicePayors={invoicePayors}
            idProductType={idProductType}
            account={account}
            idEditPayor={idEditPayor}
        />
    );
};

export default StepEnrollmentPayors;
